<script setup>
import { computed } from 'vue';
import { useCommunityMessageTagsStore } from '@/stores/community-message-tags';
import { useCommunityInteractionStore } from '@/stores/community-interactions';
import { TagGroup } from '@dashhudson/dashing-ui/tag-group';
import { useDashToast as useToast } from '@dashhudson/dashing-ui/toast';

const interactionStore = useCommunityInteractionStore();
const messageTagsStore = useCommunityMessageTagsStore();

const { addToast } = useToast({ closable: true, life: 3000 });

const interaction = computed(() => interactionStore.selectedCommunityInteraction);
const brandTags = computed(() => messageTagsStore.getSelectedBrandTags(interaction.value?.brandId));
const interactionTags = computed(() => {
  if (!brandTags.value?.length) {
    return [];
  }
  return brandTags.value.filter((t) =>
    interactionStore.selectedCommunityInteractionTagIds.includes(t.id),
  );
});

async function onRemoveTag(tag) {
  try {
    await interactionStore.removeTagFromSelectedInteraction(tag, false);
  } catch {
    addToast({
      severity: 'error',
      message: 'There was an error removing your tag',
    });
  }
}
</script>

<template>
  <div v-if="interactionTags?.length" class="dash-w-full dash-flex">
    <TagGroup
      size="md"
      :model-value="interactionTags"
      option-label="name"
      show-all
      removable
      :remove-callback="onRemoveTag"
    />
  </div>
</template>
